import envConfig from 'config/envConfig';
import { postReq } from 'services/axios/makeRequest';

const baseUrl = `${envConfig.apiAddress}/api/Disputes`;

export const addNewDispute = payload => postReq(`${baseUrl}/Create`, payload);
